import { Box } from '@customerio/pluma-components/react';

/** Message-channels step. Placeholder — content lands with the channels step PR. */
export function ChannelsStep() {
  return <Box data-testid="signup-step-channels" />;
}
